import React from 'react'

import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ToggleButton from '@mui/material/ToggleButton'
import Tooltip from '@mui/material/Tooltip'
import CheckIcon from '@mui/icons-material/Check'

const NORMAL_DIMENSION = '42px'
const MOBILE_DIMENSION = '62px'

interface RoastLevelProps {
  value: number
  label: string
  groupName?: string
  options: Array<{ id: number; value: number; label: string }>
  onChange: (newValue: number) => void
}

const RoastLevel = (props: RoastLevelProps): JSX.Element => {
  return (
    <FormControl sx={{ mb: 3, mr: 3 }}>
      <FormLabel sx={{ mb: 0.5 }}>{props.label}</FormLabel>
      <ToggleButtonGroup
        size="small"
        exclusive
        value={props.value}
        onChange={(_event: React.MouseEvent<HTMLElement>, newValue: number) => {
          if (newValue) {
            props.onChange(newValue)
          }
        }}
      >
        {[...props.options].reverse().map((x) => {
          const isSelected = x.value === props.value
          return (
            <Tooltip key={x.value} title={x.label}>
              <ToggleButton
                value={x.value}
                sx={{
                  backgroundColor: `#${x.value.toString(16)}`,
                  borderRadius: 0,
                  border: 0,
                  width: { xs: MOBILE_DIMENSION, sm: NORMAL_DIMENSION },
                  height: { xs: MOBILE_DIMENSION, sm: NORMAL_DIMENSION },
                  transition: '0.2s',
                  '&:hover': {
                    backgroundColor: `#${x.value.toString(16)}`,
                    boxShadow: `0 0 0 5px #${x.value.toString(16)}`,
                    zIndex: 2,
                  },
                  ...(isSelected && { boxShadow: `0 0 0 5px #${x.value.toString(16)}`, zIndex: 1 }),
                }}
              >
                {isSelected && <CheckIcon sx={{ color: '#ffffff' }} />}
              </ToggleButton>
            </Tooltip>
          )
        })}
      </ToggleButtonGroup>
    </FormControl>
  )
}

export default RoastLevel
